const SafetyIconEyeProtection = ({
  className,
}: { className?: string } = {}) => (
  <svg
    className={className}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      fill="white"
    />
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      stroke="#269D84"
    />
    <path
      d="M28.5749 14.6138C26.7584 13.727 22.4171 12.9091 18.0055 13.0082C13.5933 12.9098 9.25196 13.727 7.43548 14.6138C7.1749 14.7421 6.95615 14.9418 6.80474 15.1896C6.65332 15.4375 6.57548 15.7232 6.58029 16.0136L6.6098 18.2953C6.6098 20.7758 7.65261 24.3132 14.2313 23.2318C14.7908 23.1363 15.3104 22.88 15.7267 22.4942C16.143 22.1083 16.4379 21.6097 16.5755 21.059L16.955 19.7281C17.0028 19.5349 17.1054 19.3599 17.2515 19.2243C17.4197 19.0815 17.6249 18.9894 17.8433 18.9586C18.0617 18.9277 18.2844 18.9594 18.4855 19.05C18.7806 19.1969 18.9949 19.4646 19.0736 19.7829L19.4348 21.059C19.5725 21.6097 19.8674 22.1083 20.2837 22.4942C20.7 22.88 21.2196 23.1363 21.779 23.2318C28.3577 24.3125 29.4006 20.7758 29.4006 18.2946L29.4301 16.0136C29.4349 15.7232 29.357 15.4375 29.2056 15.1896C29.0542 14.9418 28.8355 14.7421 28.5749 14.6138Z"
      stroke="#171717"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.83054 15.0723L6.54984 15.2517C5.59079 15.8647 5.03157 16.9427 5.08283 18.0798V18.0798C5.13152 19.1598 5.72456 20.1414 6.65794 20.687L7.07368 20.93M29.1695 15.0723L29.4502 15.2517C30.4092 15.8647 30.9684 16.9427 30.9172 18.0798V18.0798C30.8685 19.1598 30.2754 20.1414 29.3421 20.687L28.9263 20.93"
      stroke="#171717"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SafetyIconEyeProtection
